export { BrandingForm } from './BrandingForm';

// Ory branding
export const boxyhqBranding = {
  logoUrl: '/logo.svg',
  faviconUrl: '/favicon.ico',
  companyName: 'Articul8 SSO',
  primaryColor: '#4f39f6',
};
